import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=05842f17&scoped=true&"
import script from "./Bookings.vue?vue&type=script&lang=js&"
export * from "./Bookings.vue?vue&type=script&lang=js&"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=05842f17&prod&scoped=true&lang=scss&"
import style1 from "./Bookings.vue?vue&type=style&index=1&id=05842f17&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05842f17",
  null
  
)

export default component.exports